const urlCustomerPortal = process.env.REACT_APP_ENDPOINT_CP;

const endpoints = {
  getBranding: `${urlCustomerPortal}/branding`,
  licensePlateCheck: `${urlCustomerPortal}/incidents/licenseplate`,
  processcheck: `${urlCustomerPortal}/processcheck`,
};

export default endpoints;
